// extracted by mini-css-extract-plugin
export default {"wrap":"announcementView_wrap__WzhlH","container":"announcementView_container__V4d8L","syncButton":"announcementView_syncButton__XGhG9"};